import validate from 'validate.js'

const constraints = {
  lessonId: {
    presence: true
  },
  lessonInput: {
    presence: true
  }
}

export default (data) => {
  return validate(data, constraints)
}
